export type NavCommand = "go_back" | "skip" | "progress" | "save_and_quit";

const COMMAND_MAP: Record<string, NavCommand> = {
  ":go back": "go_back",
  ":skip": "skip",
  ":progress": "progress",
  ":save and quit": "save_and_quit",
};

export function parseNavCommand(text: string): NavCommand | null {
  const trimmed = text.trim().toLowerCase();
  if (!trimmed.startsWith(":")) return null;
  for (const [keyword, cmd] of Object.entries(COMMAND_MAP)) {
    if (trimmed === keyword || trimmed.startsWith(keyword + " ") || trimmed.startsWith(keyword + "\n")) {
      return cmd;
    }
  }
  return null;
}
